<template>
  <div class="request-approval-container">
    <Email v-show="$store.state.modalStore.showNewVendorEmail" />
    <div class="request-approval-dialog">
      <div class="request-approval-content">
        <div class="request-approval-body">
          <div class="req-app-full-container">
            <div class="req-app-full-tittle">TIKET VENDOR BARU</div>
            <div class="req-app-full-wrapper" v-if="dataUpdate">
              <div class="req-app-half-container">
                <div class="half-input-wrapper">
                  <div class="hiw-label">Request ID</div>
                  <input type="text" class="hiw-text" placeholder="Otomatis dari Sistem" :value="code" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Deskripsi <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="desc"
                    oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Pengadaan <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="nama_pengadaan"
                    oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Kategori</div>
                  <select v-model="kategori_id" class="hiw-text">
                    <option v-for="(option, index) in kategoryList" :key="index" :value="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Vendor <span class="text-ast">*</span>
                  </div>
                  <div class="autocomplete">
                    <input type="text" class="hiw-text" v-model="setNamaVendor"
                      oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
                    <ul id="autocomplete-results" v-show="isOpen" class="autocomplete-results">
                      <li v-for="(result, i) in vendors" :key="i" @click="setResult(result.nama_vendor)"
                        class="autocomplete-result">
                        {{ result.nama_vendor }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    PIC Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="pic_vendor"
                    oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    No. Telepon PIC <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="no_telepon" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Email Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="email_vendor"
                    oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Priority</div>
                  <select v-model="priority" class="hiw-text">
                    <option v-for="(option, index) in priorityList" :key="index" :value="option.id">
                      {{ option.desc }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label" style="cursor: pointer">
                    Dokumen Petunjuk
                  </div>
                  <label class="btn btn-default btn-file" style="width:100%; text-align:left">
                    <i class="fas fa-download" @click="downloadDoc()"></i>
                  </label>
                </div>
              </div>
              <div class="req-app-half-container">
                <!-- <div class="half-input-wrapper">
                    <div class="hiw-label">Due By</div>
                    <div class="hiw-multiple">
                      <input class="hiw-2-row" type="date">
                      <input class="hiw-2-row" type="date">
                    </div>
                  </div> -->
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Tujuan Pendaftaran<span class="text-ast">*</span>
                  </div>
                  <select v-model="tujuan_pendaftaran" class="hiw-multiple">
                    <option v-for="(option, index) in tujuan_list" :key="index" :value="option.id">
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Bidang Usaha</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="radio" value="1" v-model="bidang_usaha_id"
                        style="margin-right: 10px" />Badan Usaha</label>
                    <label class="hiw-2-row"><input type="radio" value="2" v-model="bidang_usaha_id"
                        style="margin-right: 10px" />Perorangan</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Registrasi ke Sistem <span class="text-ast">*</span>
                  </div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_ariba" value="1"
                        style="margin-right: 10px" :disabled="freeze_ariba" />ARIBA</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_gems" value="1"
                        style="margin-right: 10px" :disabled="freeze_gems" />SAP GEMS</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bce" value="1"
                        style="margin-right: 10px" :disabled="freeze_bce" />SAP BCE</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bkes" value="1"
                        style="margin-right: 10px" :disabled="freeze_bkes" />SAP BKES</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Tipe Pendaftaran Vendor</div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row popup"><input type="radio" value="1" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Nasional
                      <span class="popuptext">PT, PT TBK, YAYASAN, CV, BUMDES, KOPERASI,
                        PERKUMPULAN</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="2" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Internasional
                      <span class="popuptext">
                        PTE LTD, LTD, PTE, CORP, INC</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="3" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Khusus
                      <span class="popuptext">Instansi Pemerintah, Bank, Rumah Sakit, Hotel, Sekolah,
                        Demurage, E-commerce</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="4" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" />Internal Memo
                      <span class="popuptext">
                        Dokumen tdk ada/lengkap, Produsen, Pabrikan, HAKI,
                        Emergency, Direksi appointment</span>
                    </label>
                    <div class="half-input-wrapper" v-if="type_pendaftaran_id == 4">
                      <div class="hiw-multiple">
                        <label class="btn btn-default btn-file">
                          <i class="fas fa-upload"></i> {{ theFileNameMemo }}
                          <input type="file" style="display: none;" @change="fileChangeHandlerMemo" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Penilaian</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_k3l" value="k3l"
                        style="margin-right: 10px" :disabled="freeze_k3l" />K3L</label>
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_kplh" value="kplh"
                        style="margin-right: 10px" :disabled="freeze_kplh" />KPLH</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Dokumen Legalitas</div>
                  <!-- <input type="file" class="hiw-text"> -->
                  <label class="btn btn-default btn-file">
                    <i class="fas fa-upload"></i> {{ theFileName }}
                    <input type="file" style="display: none;" @change="fileChangeHandler" />
                  </label>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Note</div>
                  <textarea class="hiw-area" v-model="note"
                    oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
                </div>
              </div>
            </div>
            <div class="req-app-full-btn-wrapper">
              <div class="req-app-btn-submit mr10" @click="checkVendorName()">
                Update Vendor
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../services/config'
export default {
  components: {
    Email: () => import('@/components/modal/newVendorEmail.vue'),
  },
  data() {
    return {
      chooseBu: '',
      chooseTypeRegister: '',
      chooseAssesment: [],
      chooseServer: [],
      files: [],
      memoFiles: [],

      priorityList: [
        {
          id: 1,
          desc: 'Very High',
        },
        {
          id: 2,
          desc: 'High',
        },
        {
          id: 3,
          desc: 'Medium',
        },
        {
          id: 4,
          desc: 'Low',
        },
        {
          id: 5,
          desc: 'Very Low',
        },
      ],
      kategoryList: [
        {
          id: 1,
          desc: 'CAT - Category 1',
        },
        {
          id: 2,
          desc: 'GIL - GA,IT & LONG TAILS',
        },
        {
          id: 3,
          desc: 'FEL - FUEL, LUBRICANT & ENERGY',
        },
        {
          id: 4,
          desc: 'MRR - MAINTENANCE & REPAIR, RENTAL',
        },
        {
          id: 5,
          desc: 'CPI - COAL PROCESSING & INFRASTRUCTURE PROJECT',
        },
      ],
      tujuan_list: [],

      code: '',
      desc: '',
      nama_pengadaan: '',
      tujuan_pendaftaran: 1,
      kategori_id: 1,
      nama_vendor: '',
      pic_vendor: '',
      no_telepon: '',
      email_vendor: '',
      priority: 5,

      //due_date:,
      bidang_usaha_id: 1,
      type_pendaftaran_id: 1,
      register_ariba: true,
      register_gems: false,
      register_bce: false,
      register_bkes: false,
      freeze_ariba: true,
      freeze_gems: true,
      freeze_bkes: true,
      freeze_bce: true,
      assesment_k3l: false,
      assesment_kplh: false,
      freeze_k3l: false,
      freeze_kplh: false,
      note: '',

      vendors: [],
      isOpen: false,
    }
  },
  async created() {
    await this.getPurposeTicket()
    await this.getVendorCategory()
    await this.$store.dispatch('myRequest/requestDetail', this.$route.params.id)
  },
  computed: {
    setNamaVendor: {
      get() {
        return this.nama_vendor
      },
      set(newValue) {
        if (newValue.length > 4) {
          this.getVendor(newValue)
        }
        if (newValue.length == 0) {
          this.isOpen = false
        }
        this.nama_vendor = newValue
      },
    },
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.$get(
        this.$store,
        'state.myRequest.detail.dokumen_legalitas_originalname',
        'Upload Dokumen'
      )
    },
    theFileNameMemo() {
      if (this.memoFiles.length > 0 && 'name' in this.memoFiles[0]) {
        return this.memoFiles[0].name
      }
      return this.$get(
        this.$store,
        'state.myRequest.detail.internal_memo_originalname',
        'Upload Internal Memo'
      )
    },
    dataUpdate() {
      this.code = this.$get(this.$store, 'state.myRequest.detail.code', '')
      this.desc = this.$get(this.$store, 'state.myRequest.detail.desc', '')
      this.nama_pengadaan = this.$get(
        this.$store,
        'state.myRequest.detail.nama_pengadaan',
        ''
      )
      this.kategori_id = this.$get(
        this.$store,
        'state.myRequest.detail.kategori_id',
        1
      )
      this.tujuan_pendaftaran = this.$get(
        this.$store,
        'state.myRequest.detail.tujuan_pendaftaran',
        null
      )
      this.nama_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.nama_vendor'
      )
      this.pic_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.pic_vendor'
      )
      this.no_telepon = this.$get(
        this.$store,
        'state.myRequest.detail.no_telepon'
      )
      this.email_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.email_vendor'
      )
      this.priority = this.$get(
        this.$store,
        'state.myRequest.detail.priority',
        5
      )
      this.bidang_usaha_id = this.$get(
        this.$store,
        'state.myRequest.detail.bidang_usaha_id',
        1
      )
      this.type_pendaftaran_id = this.$get(
        this.$store,
        'state.myRequest.detail.type_pendaftaran_id',
        1
      )
      this.register_gems = this.$get(
        this.$store,
        'state.myRequest.detail.register_gems',
        false
      )
      this.register_bce = this.$get(
        this.$store,
        'state.myRequest.detail.register_bce',
        false
      )
      this.register_bkes = this.$get(
        this.$store,
        'state.myRequest.detail.register_bkes',
        false
      )
      this.assesment_k3l = this.$get(
        this.$store,
        'state.myRequest.detail.assesment_k3l',
        false
      )
      this.assesment_kplh = this.$get(
        this.$store,
        'state.myRequest.detail.assesment_kplh',
        false
      )
      this.note = this.$get(this.$store, 'state.myRequest.detail.note', '')

      return true
    },
  },
  watch: {
    tujuan_pendaftaran(newValue) {
      if (this.tujuan_list.length > 0) {
        const { ariba_registration, gems_registration, bce_registration, bkes_registration } = this.tujuan_list.filter(
          i => i.id == newValue
        )[0]

        if (newValue == 1 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 1 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 2 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 2 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 3 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = false
          this.freeze_kplh = false
        } else if (newValue == 3 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 4 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 4 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 5 && this.bidang_usaha_id == 1) {
          this.register_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).checked : false
          this.register_gems = this.checkPurposeTicketChecklist(gems_registration).checked
          this.register_bce = this.checkPurposeTicketChecklist(bce_registration).checked
          this.register_bkes = this.checkPurposeTicketChecklist(bkes_registration).checked
          this.freeze_ariba = ariba_registration ? this.checkPurposeTicketChecklist(ariba_registration).disabled : false
          this.freeze_gems = this.checkPurposeTicketChecklist(gems_registration).disabled
          this.freeze_bce = this.checkPurposeTicketChecklist(bce_registration).disabled
          this.freeze_bkes = this.checkPurposeTicketChecklist(bkes_registration).disabled
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        } else if (newValue == 5 && this.bidang_usaha_id == 2) {
          this.register_ariba = false
          // this.register_gems = false
          // this.register_bce = false
          // this.register_bkes = false
          this.freeze_ariba = true
          this.freeze_gems = false
          this.freeze_bce = false
          this.freeze_bkes = false
          this.assesment_k3l = false
          this.assesment_kplh = false
          this.freeze_k3l = true
          this.freeze_kplh = true
          this.assesment_k3l = false
          this.assesment_kplh = false
        }
      }
    },
  },
  methods: {
    async getPurposeTicket() {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/m-purpose-ticket`,
        })

        this.tujuan_list = data.data
      } catch (error) {
        // do nothing
      }
    },
    async getVendorCategory() {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/m-ticket-category`,
        })

        this.kategoryList = data.data
      } catch (error) {
        // do nothing
      }
    },
    checkForm(request) {
      let arr = [
        [request.desc, 'Deskripsi'],
        [request.nama_pengadaan, 'Nama Pengadaan'],
        [request.nama_vendor, 'Nama Vendor'],
        [request.pic_vendor, 'PIC Vendor'],
        [request.no_telepon, 'No. Tlp PIC'],
        [this.isEmailValid(this.email_vendor), 'Email Vendor'],
        [request.tujuan_pendaftaran, 'Tujuan Pendafataran'],
        [
          request.register_gems ||
          request.register_bce ||
          request.register_bkes ||
          this.register_ariba,
          'Registrasi ke Sistem',
        ],
      ]

      if (request.type_pendaftaran_id == 4 && this.memoFiles.length > 0) {
        arr = [...arr, [this.memoFiles.length > 0, 'Internal Memo']]
      }

      return this.multiConditions(arr)
    },
    checkVendorName() {
      let request = {
        desc: this.desc,
        nama_pengadaan: this.nama_pengadaan,
        kategori_id: this.kategori_id,
        nama_vendor: this.nama_vendor,
        email_vendor: this.email_vendor,
        pic_vendor: this.pic_vendor,
        no_telepon: this.no_telepon,
        priority: this.priority,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        register_gems: this.register_gems,
        register_bce: this.register_bce,
        register_bkes: this.register_bkes,
        assesment_k3l: this.assesment_k3l,
        assesment_kplh: this.assesment_kplh,
        note: this.note,
        tujuan_pendaftaran: this.tujuan_pendaftaran,
      }

      if (this.files && this.files.length > 0) {
        request['dokumen_legalitas'] = this.files[0]
      }
      if (this.memoFiles && this.memoFiles.length > 0) {
        request['internal_memo'] = this.memoFiles[0]
      }

      const url = `${api}/api/v1/vendor-level-1?page=1&limit=10&search=${this.nama_vendor}`

      if (this.checkForm(request)) {
        this.$store.commit('SET_GLOBAL_LOADING', true)
        axios({
          method: 'get',
          url,
        })
          .then(({ data }) => {
            this.$store.commit('SET_GLOBAL_LOADING', false)

            let searchName = data.data.filter(
              i => i.nama_vendor == this.nama_vendor
            )

            if (searchName.length == 1) {
              if (
                confirm(
                  'Nama Vendor terdeteksi duplikat, apakah Anda yakin untuk melanjutkan pendaftaran Vendor?'
                )
              ) {
                // Save it!
              } else {
                // Do nothing!
              }
            }
            this.update(request)
          })
          .catch(error => {
            this.$store.commit('SET_GLOBAL_LOADING', false)
            this.update(request)
          })
      }
    },
    setResult(value) {
      this.nama_vendor = value
      this.isOpen = false
    },
    async getVendor(search) {
      this.vendors = await this.$autoComplete(search)

      if (this.vendors.length > 0) {
        this.isOpen = true
      } else {
        this.isOpen = false
      }
    },
    resetForm() {
      this.desc = ''
      this.nama_pengadaan = ''
      this.kategori_id = 1
      this.nama_vendor = ''
      this.pic_vendor = ''
      this.no_telepon = ''
      this.priority = 5
      this.bidang_usaha_id = 1
      this.type_pendaftaran_id = 1
      this.register_gems = false
      this.register_bce = false
      this.register_bkes = false
      this.assesment_k3l = false
      this.assesment_kplh = false
      this.note = null
      this.files = []
      this.email_vendor = ''
    },
    update(request) {
      const self = this
      let url = `${api}/api/v1/request/vendor/${this.$route.params.id}`

      const id = String(this.$route.params.id)
      const status = String(this.$route.params.status)

      this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

      let bodyFormData = new FormData()
      request.dokumen_legalitas &&
        bodyFormData.append('dokumen_legalitas', request.dokumen_legalitas)
      request.internal_memo &&
        bodyFormData.append('internal_memo', request.internal_memo)
      request.tujuan_pendaftaran &&
        bodyFormData.append('tujuan_pendaftaran', request.tujuan_pendaftaran)
      request.email_vendor &&
        request.email_vendor != '' &&
        bodyFormData.append('email_vendor', request.email_vendor)
      bodyFormData.append('desc', request.desc)
      bodyFormData.append('nama_pengadaan', request.nama_pengadaan)
      bodyFormData.append('kategori_id', request.kategori_id)
      bodyFormData.append('nama_vendor', request.nama_vendor)
      bodyFormData.append('pic_vendor', request.pic_vendor)
      bodyFormData.append('priority', request.priority)
      bodyFormData.append('bidang_usaha_id', request.bidang_usaha_id)
      bodyFormData.append('type_pendaftaran_id', request.type_pendaftaran_id)
      bodyFormData.append('register_gems', request.register_gems)
      bodyFormData.append('register_bce', request.register_bce)
      bodyFormData.append('register_bkes', request.register_bkes)
      bodyFormData.append('assesment_k3l', request.assesment_k3l)
      bodyFormData.append('assesment_kplh', request.assesment_kplh)
      bodyFormData.append('note', request.note)
      bodyFormData.append('user_id', this.$store.state.userid)
      bodyFormData.append('type', 1)
      bodyFormData.append('no_telepon', request.no_telepon)

      axios({
        method: 'PUT',
        url,
        data: bodyFormData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(function (response) {
          self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          self.resetForm()
          self.$store.commit('SET_NOTIF', 'Permintaan Anda sedang di Proses')
          // self.$router.push({ path: '/' })
          // self.$router.push({ path: `/approval/detail/${this.$route.params.id}/${this.$route.params.status}`})
          self.$router.push({ path: `/approval/detail/${id}/${status}` })
        })
        .catch(function (error) {
          self.$store.commit(
            'SET_NOTIF',
            self.$get(error, 'response.data.message', 'Error')
          )
          self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        })
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
    fileChangeHandlerMemo(e) {
      this.memoFiles = Array.from(e.target.files)
    },
    downloadDoc() {
      const fileName = `JKT - ISUPPLIER\ISUPPLIER\Dokumen Isupplier\Dokumen Petunjuk.pdf`
      const fileLocation = `JKT%20-%20ISUPPLIER/ISUPPLIER/Dokumen%20Isupplier/Dokumen%20Petunjuk.pdf`
      if (fileLocation) {
        let linkUrl = `${api}/file/${fileLocation}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(fileName))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
  },
}
</script>

<style scoped>
.autocomplete {
  position: relative;
  width: 100%;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  height: 120px;
  overflow: auto;
  width: 100%;
  position: relative;
  bottom: 0;
  left: 0;
  background-color: #fff;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>
